<script>
export default {
    name: "QueueDashboard",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

      "inpatient-tab": () => import('./tabs/Inpatient.vue'),
      "inpatientorder-tab": () => import('./tabs/InpatientOrder.vue'),
      "outpatient-tab": () => import('./tabs/OutPatient.vue'),
      "requisitions-tab": () => import('./tabs/Requisitions.vue'),
      "discharged-tab": () => import('./tabs/Discharged.vue'),
      "ordersummary-tab": () => import('./tabs/OrderSummary.vue'),
      "order-bulk-issue-tab": () => import('./tabs/OrderBulkIssue.vue'),
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-medium text-sm">Pharmacy</h5>
        </template>
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
                <ul class="w-full flex border-b mb-2">
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 0" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active== 0 ?  activeClass : inActiveClass" 
                      href="javascript:void(0)">Store Requisitions</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 2" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 2 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Inpatient List</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 3" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 3 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Outpatient List</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 1" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 1 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Discharged List</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 5" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 5 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Order Summary</a>
                  </li> <li class="-mb-px mr-1">
                    <a @click.prevent="active = 6" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 6 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Order Bulk Issue </a>
                  </li>
                </ul>
                <inpatient-tab v-if="active === 4" />
                <outpatient-tab v-if="active === 3" />
                <requisitions-tab v-if="active === 0" />
                <discharged-tab v-if="active === 1" />
                <inpatientorder-tab v-if="active===2"/>
                <ordersummary-tab v-if="active===5"/>
                <order-bulk-issue-tab v-if="active===6"/>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
